export const mixerConfig = {
  type: "object"
};
export const nullableMixerConfig = {
  ...mixerConfig,
  type: ["null", "object"]
};
